import { useEffect, useState } from 'react';
import io from 'socket.io-client';
import { v4 as uuidv4 } from 'uuid';

// const socket = io(process.env.REACT_APP_SOCKET_URL); // Replace with your server URL if needed
const socket = io(process.env.REACT_APP_SOCKET_URL, { autoConnect: false });

// Event listener
socket.on('connect', () => {
});;

// Custom hook for managing socket
const useSocket = () => {

    const [progress, setProgress] = useState(null); // Store progress data
    const [uploadId, setUploadId] = useState(); // Store progress data

    useEffect(() => {
        // Emit a hello message once connected
        socket.emit('client-connected', '------------------Hello from React!------------------');

        const newUploadId = uuidv4();
        setUploadId(newUploadId)

        // Listen for progress updates
        socket.on('progress', (data) => {
            if (progress !== data.percentage && newUploadId === data.uploadId) {
                setProgress(Number(data.percentage));
            }
        });

        socket.on('progress-completed', (data) => {
            setProgress(Number(data.percentage));
            socket.disconnect();
        })

        socket.on('client-connected', (socket) => {
            console.log(socket)
        });

        return;
    }, []);

    return { progress, uploadId }; // Return progress data
};

const connectSocket = () => {
    socket.connect();

    return socket;
};


export { connectSocket };
export default useSocket;